// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bo-0";
export var headerCellHover = "_bo-1";